export default __webpack_public_path__ + "static/media/SheetMetalImg1.bd9be4fd.jpg";